var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure-img"},[_c('el-image',{attrs:{"src":_vm.structureImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }